module.exports = __webpack_public_path__ + "img/delphinus-logo.7a8ef5e3.svg";